import { Pipe, PipeTransform } from '@angular/core';
import { ApiTravelHelperService } from './travel-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiTravel',
})
export class ApiTravelHelperPipe implements PipeTransform {
  constructor(private _apiTravelHelperSrv: ApiTravelHelperService) {}

  transform(travel: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiTravelHelperSrv as any)['get' + ucFirst(fct)](
      travel,
      ...args
    );
  }
}

@Pipe({
  name: 'apiTravelU',
  pure: false,
})
export class ApiTravelHelperUnPurePipe
  extends ApiTravelHelperPipe
  implements PipeTransform {}
